import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

export default function VideoLightbox({ open, image, videoSrc, caption, onClose }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="fixed inset-0 z-[110] flex items-center justify-center p-4" data-testid="scene-lightbox">
          <div className="absolute inset-0 bg-[#1A243A]/80 backdrop-blur-md" onClick={onClose} />
          <motion.div initial={{ scale: 0.92, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.92, opacity: 0 }} className="relative w-full max-w-3xl">
            <button onClick={onClose} data-testid="scene-close" className="absolute -top-12 right-0 text-white/90 hover:text-white flex items-center gap-2 text-sm"><X size={20} /> {caption?.close}</button>
            <div className="relative rounded-3xl overflow-hidden shadow-2xl aspect-video bg-black">
              {videoSrc ? (
                <video src={videoSrc} autoPlay loop controls playsInline className="w-full h-full object-cover" />
              ) : (
                <motion.img
                  src={image}
                  alt=""
                  className="w-full h-full object-cover"
                  initial={{ scale: 1, x: 0, y: 0 }}
                  animate={{ scale: [1, 1.12, 1.08, 1], x: [0, -18, 12, 0], y: [0, 10, -8, 0] }}
                  transition={{ duration: 9, repeat: Infinity, ease: "easeInOut" }}
                />
              )}
              <div className="absolute inset-0 pointer-events-none bg-gradient-to-t from-[#1A243A]/40 via-transparent to-transparent" />
            </div>
            <p className="mt-4 text-center text-white/80 text-sm">{caption?.text}</p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
